import { z } from "zod/v3";

/**
 * Событие realtime «уведомления прочитаны на другом устройстве».
 *
 * `id` — одно прочитанное уведомление, `all` — прочитаны все. Это лишь повод
 * перечитать durable-состояние, поэтому неожиданная форма не ошибка: тогда
 * список и счётчик всё равно обновляются, просто без точечных действий.
 */
export const notificationsReadEventSchema = z.object({
  id: z.string().nullable(),
  all: z.boolean(),
});

export type NotificationsReadEvent = z.infer<typeof notificationsReadEventSchema>;

export function parseNotificationsReadEvent(payload: unknown): NotificationsReadEvent {
  const parsed = notificationsReadEventSchema.safeParse(payload);
  return parsed.success ? parsed.data : { id: null, all: false };
}
